/* SellEton tech help chat (2026-10-24). No library. Talks to the Netlify function; keeps the
   conversation in sessionStorage only (cleared when the tab closes). */
(function () {
  var root = document.getElementById('se-chat');
  if (!root) return;
  var KEY = 'se_chat_log', GATE = 'se_chat_preview';
  try {
    if (/[?&]chat=preview\b/.test(location.search)) sessionStorage.setItem(GATE, '1');
    if (root.dataset.mode !== 'live' && sessionStorage.getItem(GATE) !== '1') return;
  } catch (e) { if (root.dataset.mode !== 'live') return; }
  // The snippet is rendered inside the selleton_fixes block, which the theme hides on purpose; live on <body> instead.
  if (root.parentElement !== document.body) document.body.appendChild(root);
  root.hidden = false;

  var openBtn = root.querySelector('.se-chat__open'), panel = root.querySelector('.se-chat__panel'),
      closeBtn = root.querySelector('.se-chat__close'), log = root.querySelector('.se-chat__log'),
      quick = root.querySelector('.se-chat__quick'), form = root.querySelector('.se-chat__form'),
      input = form.querySelector('textarea'), send = form.querySelector('.se-chat__send');
  var GREETING = 'Hi, this is SellEton tech help. Tell me your indicator model (for example SL-7510 or SL-7515-C) and what the screen shows, and I will get you the right video and steps.';
  var CHIPS = ['Error 6 or UUUUU on screen', 'How do I calibrate?', 'Is my scale under warranty?', 'I need a replacement part'];
  var messages = [];
  var openedAt = 0;
  var sid = '';
  try { sid = sessionStorage.getItem('se_chat_sid') || ('c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7)); sessionStorage.setItem('se_chat_sid', sid); } catch (e) {}
  try { messages = JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) {}

  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(messages.slice(-24))); } catch (e) {} }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var SAFE = /^https:\/\/(selletonscales\.com|www\.selletonscales\.com|youtu\.be|www\.youtube\.com|youtube\.com|cdn\.shopify\.com)\//i;
  function ytId(u) { var m = u.match(/(?:youtu\.be\/|v=)([\w-]{11})/); return m ? m[1] : null; }

  function render(text, who) {
    var el = document.createElement('div');
    el.className = 'se-chat__msg se-chat__msg--' + who;
    var shown = 0;
    var html = esc(text).replace(/https:\/\/[^\s<)"]+/g, function (u) {
      var raw = u.replace(/&amp;/g, '&').replace(/[.,;:!?]+$/, '');
      var tail = u.slice(esc(raw).length);
      if (!SAFE.test(raw)) return u;
      var id = ytId(raw);
      // A video shows once, as a picture card in place of its address (rule 23: no second link to the same thing).
      if (id && who === 'bot' && shown++ < 3) {
        return '<a class="se-chat__video" href="https://www.youtube.com/watch?v=' + id + '" target="_blank" rel="noopener">' +
          '<span class="se-chat__thumb"><img loading="lazy" alt="" width="480" height="270" src="https://i.ytimg.com/vi/' + id + '/hqdefault.jpg"></span>' +
          '<span class="se-chat__watch">Watch the video</span></a>' + tail;
      }
      var label = /\/products\//.test(raw) ? 'View the part' : /\/collections\//.test(raw) ? 'View the parts' :
        /request-support|query-tech-support/.test(raw) ? 'Request support form' : /warranty-policy/.test(raw) ? 'Warranty policy' :
        /youtu/.test(raw) ? 'Watch the video' : raw.replace(/^https:\/\/(www\.)?/, '');
      return '<a href="' + esc(raw) + '" target="_blank" rel="noopener">' + esc(label) + '</a>' + tail;
    });
    var mail = root.querySelector('.se-chat__foot a[href^="mailto:"]');
    // The tech email is always written in lowercase (THE ROUND, 2026-10-25), whatever case the answer used.
    if (mail && who === 'bot') html = html.replace(/tech@selletonscales\.com/gi, '<a href="' + esc(mail.getAttribute('href')) + '">tech@selletonscales.com</a>');
    el.innerHTML = html.replace(/\n*(<a class="se-chat__video")/g, '$1').replace(/(Watch the video<\/span><\/a>)\n/g, '$1');
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
  }

  function chips(show) {
    quick.innerHTML = '';
    if (!show) return;
    CHIPS.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'se-chat__chip'; b.textContent = t;
      b.addEventListener('click', function () { ask(t); });
      quick.appendChild(b);
    });
  }

  function paint() {
    log.innerHTML = '';
    render(GREETING, 'bot');
    messages.forEach(function (m) { render(m.content, m.role === 'user' ? 'me' : 'bot'); });
    chips(messages.length === 0);
  }

  function ask(text) {
    text = String(text || '').trim();
    if (!text || send.disabled) return;
    messages.push({ role: 'user', content: text.slice(0, 1500) });
    save(); render(text, 'me'); chips(false);
    input.value = ''; send.disabled = true;
    var typing = document.createElement('div');
    typing.className = 'se-chat__typing'; typing.setAttribute('aria-label', 'Looking that up'); typing.innerHTML = '<i></i><i></i><i></i>';
    log.appendChild(typing); log.scrollTop = log.scrollHeight;
    fetch(root.dataset.endpoint, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ messages: messages, sid: sid, hp: (form.querySelector('[name=se_hp]') || {}).value || '', t: openedAt ? Date.now() - openedAt : -1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { return d && d.reply ? d.reply : null; })
      .catch(function () { return null; })
      .then(function (reply) {
        typing.remove(); send.disabled = false;
        reply = reply || 'Sorry, I could not reach our system just now. Please use the Request support form at https://selletonscales.com/pages/request-support or email tech@selletonscales.com and a technician will help.';
        messages.push({ role: 'assistant', content: reply });
        save(); render(reply, 'bot'); input.focus();
      });
  }

  function open(on) {
    root.classList.toggle('is-open', on);
    panel.hidden = !on; openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) { openedAt = openedAt || Date.now(); paint(); input.focus(); } else { openBtn.focus(); }
  }

  // Phones: the launcher never sits over a page button or a price (rule 30; THE ROUND 2026-10-26). It steps aside while one is under it
  // and comes back when the spot is clear; checked on scroll, resize and once a second for late content.
  // From 1000 px up no stepping aside is needed: the launcher is a slim tab in the page's right gutter (se-tech-chat.css, v67).
  var phone = window.matchMedia ? window.matchMedia('(max-width: 999px)') : { matches: false };
  // Real buttons (add to cart, checkout, quote, call, send) and the option rows and group headers of the buy box; a whole product card is a link but not a button.
  var CONTROL = 'button,input[type="submit"],input[type="button"],[role="button"],a[class*="btn"],a[class*="button"],a[class*="cta"],a[href^="tel:"],.gpo-app label,.gpo-group__header,footer a[href],.site-footer a[href],.se-specs__item,.productitem--title a'; /* v77 (2026-10-27, office ROUND gate): the product page spec boxes and the product card titles count too, so the round icon never sits over them */ /* v76 (2026-10-27, the tech help chat's phone sweep): footer links count too, the wider pill reached Contact us, the programs, the social icons and the tech email; a whole product card stays a link, not a button */
  // Does a button, an option row of the buy box or a price overlap the box r? Plain geometry, the way the eye judges it
  // (a hit test at a few points can land between two rows). self = the element being checked; the chat and the back to top button never count.
  function overlaps(a, b) { return !(a.right <= b.left || a.left >= b.right || a.bottom <= b.top || a.top >= b.bottom); }
  function shown(el) { var st = getComputedStyle(el); return st.visibility !== 'hidden' && st.display !== 'none' && st.opacity !== '0'; }
  function isPriceLeaf(el) { if (el.classList && el.classList.contains('money')) return true; return el.children && el.children.length === 0 && /\$\s?\d/.test(el.textContent || ''); }
  function coveredAt(r, self) {
    if (!r.width) return false;
    var cs = document.querySelectorAll(CONTROL), i, b;
    for (i = 0; i < cs.length; i++) {
      var c = cs[i];
      if (root.contains(c) || (self && self.contains(c)) || c.classList.contains('se-ft-top')) continue;
      b = c.getBoundingClientRect(); if (b.width && b.height && overlaps(b, r) && shown(c)) return true;
    }
    var ps = document.querySelectorAll('.money, .gpo-app span, .price, [class*="price"]');
    for (i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (root.contains(p) || !isPriceLeaf(p)) continue;
      b = p.getBoundingClientRect(); if (b.width && b.height && overlaps(b, r) && shown(p)) return true;
    }
    return false;
  }
  // Measure the fixed box, not the button: a tucked button is scaled down, and measuring it made the check flip on and off.
  function covered() { return coveredAt(root.getBoundingClientRect(), null); }
  var pending = false, topBtn = null;
  function tuck() {
    pending = false;
    var on = phone.matches && !root.classList.contains('is-open');
    root.classList.toggle('se-chat--tucked', on && covered());
    // The theme's back to top button follows the same rule under 1000 px (THE ROUND gate 2026-10-26: it sat over the Printers row on the phone).
    if (!topBtn || !topBtn.isConnected) topBtn = document.querySelector('.se-ft-top');
    // Set as an inline style, so it holds whatever the theme does to the button's classes while it fades in and out.
    if (topBtn) { var hideTop = on && coveredAt(topBtn.getBoundingClientRect(), topBtn); topBtn.style.setProperty('opacity', hideTop ? '0' : '', 'important'); topBtn.style.setProperty('pointer-events', hideTop ? 'none' : '', 'important'); }
  }
  function soon() { if (!pending) { pending = true; requestAnimationFrame(tuck); } }
  window.addEventListener('scroll', soon, { passive: true });
  window.addEventListener('resize', soon);
  setInterval(soon, 1000);
  soon();

  openBtn.addEventListener('click', function () { open(true); });
  // The Support Center page's Still stuck block opens this same chat (one chat per page, rule 23):
  //   <button data-se-chat-open data-se-chat-ask="optional first message">Ask the AI tech help</button>
  window.seTechChat = { open: function (text) { open(true); if (text) { openedAt = Date.now() - 2000; ask(text); } } };
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-se-chat-open]');
    if (t) { e.preventDefault(); window.seTechChat.open(t.getAttribute('data-se-chat-ask')); }
  });
  closeBtn.addEventListener('click', function () { open(false); });
  root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) open(false); });
  form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); });
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); ask(input.value); } });
})();
